import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MoneyValue } from '@client/api';

import { toMoneyString } from '../moneyUtils';
import { combineStrings } from '../stringUtils';

export const useTotalAmountString = (
  yearlyValue?: MoneyValue | null,
  oneTimeValue?: MoneyValue | null,
  placeholder?: string
) => {
  const { t: tType } = useTranslation('type');

  const yearlyAmount = useMemo(() => (!yearlyValue?.amount ? undefined : toMoneyString(yearlyValue)), [yearlyValue]);

  const oneTimeAmount = useMemo(
    () => (!oneTimeValue?.amount ? undefined : toMoneyString(oneTimeValue)),
    [oneTimeValue]
  );

  const yearlyAmountWithInterval = useMemo(
    () => (!yearlyAmount ? undefined : combineStrings(' / ', yearlyAmount, tType('IntervalType.Year'))),
    [yearlyAmount, tType]
  );

  const oneTimeAmountWithInterval = useMemo(
    () => (!oneTimeAmount ? undefined : combineStrings(' ', oneTimeAmount, tType('PriceType.OneTime'))),
    [oneTimeAmount, tType]
  );

  if (!yearlyAmountWithInterval && !oneTimeAmountWithInterval) return placeholder;

  return combineStrings(' + ', oneTimeAmountWithInterval, yearlyAmountWithInterval);
};
